<main class="pol">
  <header class="pol__head">
    <a class="pol__brand" href="/">
      <img src="/assets/images/favicon_mmonline.png" alt="" width="28" height="28">
      <span>Measure Map Online</span>
    </a>
  </header>

  <article class="pol__doc">
    <h1>{{strings['cookie_policy']}}</h1>
    <p class="pol__meta">{{getString('cookie_policy_version', version)}}</p>

    <div class="pol__cta">
      <p>{{strings['cookie_policy_cta']}}</p>
      <button class="pol__btn" type="button" (click)="consent.openSettings()">
        <mat-icon aria-hidden="true">tune</mat-icon>{{strings['cookie_settings']}}
      </button>
    </div>

    <section>
      <h2>{{strings['cookie_pol_who_title']}}</h2>
      <p>{{strings['cookie_pol_who']}}</p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_what_title']}}</h2>
      <p>{{strings['cookie_pol_what']}}</p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_use_title']}}</h2>
      <p>{{strings['cookie_pol_use']}}</p>
      @for (category of categories; track category.id) {
        <h3>
          {{strings[category.titleKey]}}
          <span class="pol__tag" [class.pol__tag--consent]="!category.alwaysOn">
            {{strings[category.alwaysOn ? 'cookie_no_consent_needed' : 'cookie_consent_needed']}}
          </span>
        </h3>
        <p>{{strings[category.descriptionKey]}}</p>
        <app-cookie-table [category]="category"></app-cookie-table>
      }
    </section>

    <section>
      <h2>{{strings['cookie_pol_consent_title']}}</h2>
      <p>{{strings['cookie_pol_consent']}}</p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_third_title']}}</h2>
      <p>{{strings['cookie_pol_third']}}</p>
      <p>{{strings['cookie_pol_services']}}</p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_browser_title']}}</h2>
      <p>{{strings['cookie_pol_browser']}}</p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_rights_title']}}</h2>
      <p>
        {{strings['cookie_pol_rights']}}
        <a href="https://measuremaponline.com/privacy" target="_blank" rel="noopener">{{strings['privacy_policy']}}</a>
        ·
        <a href="https://www.aepd.es" target="_blank" rel="noopener">aepd.es</a>
      </p>
    </section>

    <section>
      <h2>{{strings['cookie_pol_changes_title']}}</h2>
      <p>{{strings['cookie_pol_changes']}}</p>
    </section>
  </article>
</main>
